import env from '@/lib/env'

export const PRODUCTS = [
  {
    bgColor: '#203E4A44',
    image: {
      src: `${env.BASE_PATH}/static/images/other-products/consentwow-section.svg`,
      alt: 'Consent Wow',
    },
    href: 'https://consentwow.com',
    action: 'Click consent wow',
  },
  {
    bgColor: '#EA834F44',
    image: {
      src: `${env.BASE_PATH}/static/images/other-products/cookie-section.svg`,
      alt: 'Cookie Wow',
    },
    href: 'https://cookiewow.com',
    action: 'Click cookie wow',
  },
  {
    bgColor: '#00E3AB44',
    image: {
      src: `${env.BASE_PATH}/static/images/other-products/pdpa-pro-section.svg`,
      alt: 'PDPA Pro',
    },
    href: 'https://pdpa.pro',
    action: 'Click pdpa pro',
  },
  {
    bgColor: '#2879F944',
    image: {
      src: `${env.BASE_PATH}/static/images/other-products/pdpaform-section.svg`,
      alt: 'PDPA Form',
    },
    href: 'https://pdpaform.com',
    action: 'Click pdpa form',
  },
  {
    bgColor: '#104EBC44',
    image: {
      src: `${env.BASE_PATH}/static/images/other-products/learn-pdpa-section.svg`,
      alt: 'LearnPDPA',
    },
    href: 'https://learnpdpa.com',
    action: 'Click learn pdpa',
  },
]
